<template>
  <div>
    <v-dialog v-model="dialog" eager persistent scrollable max-width="600">
      <v-form ref="StudentReqForm" @submit.prevent>
        <v-card>
          <v-card-title class="d-flex align-center">
            <span>{{ action }} Requirement</span>
            <v-spacer></v-spacer>
            <v-btn icon="mdi-close" variant="text" @click="closeD()"> </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="name"
                    readonly
                    :rules="[formRules.required]"
                    label="Name"
                    :color="$vuetify.theme.themes.light.inputColor"
                    variant="outlined"
                    density="compact"
                  ></v-text-field>
                </v-col>
                <v-col v-if="action != 'View'">
                  <v-file-input
                    v-model="file"
                    :rules="[formRules.required, formRules.isPDFFile]"
                    variant="outlined"
                    density="compact"
                    accept="application/pdf"
                    label="File"
                  ></v-file-input>
                </v-col>

                <v-col v-if="remarks" cols="12">
                  <v-textarea
                    v-model="remarks"
                    readonly
                    variant="outlined"
                    density="compact"
                    rows="5"
                    label="Remarks"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-2 mr-4">
            <v-btn
              color="green"
              density="comfortable"
              variant="flat"
              v-if="requirement_submission_id"
              @click="viewFile(filename)"
            >
              <v-icon>mdi-text-box-search-outline</v-icon>
              view file
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="red"
              outlined
              @click="closeD()"
              v-if="action != 'View'"
            >
              <v-icon>mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>
            <v-btn
              v-if="action != 'View'"
              :color="$vuetify.theme.themes.light.submitBtns"
              class="white--text"
              density="comfortable"
              variant="flat"
              :disabled="btnLoading"
              :loading="btnLoading"
              @click="action == 'Upload' ? save() : update()"
            >
              <v-icon>mdi-check-circle</v-icon>
              {{ action == "Upload" ? "Upload" : "Update" }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import eventBus from "@/eventBus";
export default {
  props: {
    data: Object,
    action: String,
  },
  data() {
    return {
      dialog: false,
      showDatePicker: false,
      name: null,
      requirement_id: null,
      requirement_submission_id: null,
      file: null,
      filename: null,
      remarks: null,
      btnLoading: false,
      deletedFile: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
    };
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        this.initialize();
        this.$refs.StudentReqForm.resetValidation();
        this.$refs.StudentReqForm.reset();
        this.name = data.requirement_name;
        this.file = null;
        this.remarks = data.remarks;
        this.requirement_submission_id = data.requirement_submission_id;
        this.requirement_id = data.requirement_id;
        this.filename = data.file;
      },
      deep: true,
    },
  },
  methods: {
    initialize() {
      this.getPrograms();
    },

    saveDate() {
      if (this.valid_until) {
        this.valid_until = this.formatDate3(this.valid_until);
      }
      this.showDatePicker = false;
    },

    deleteFile() {
      console.log(typeof this.moa_file);
      if (typeof this.moa_file == "string") {
        this.deletedFile = this.moa_file;
      }

      this.moa_file = null;
      this.file_desc = null;
      this.valid_until = null;
    },

    async save() {
      let formValid = await this.$refs.StudentReqForm.validate();

      if (formValid.valid) {
        this.btnLoading = true;
        let data = {
          requirement_id: this.requirement_id,
        };
        let fd = new FormData();
        fd.append("data", JSON.stringify(data));
        fd.append("file", this.file);
        this.axiosCall(
          "/student-requirement-submission/submitRequirement",
          "POST",
          fd,
        ).then((res) => {
          if (res.data.status == 201) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
            this.btnLoading = false;
            this.closeD();
          } else {
            this.btnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
          }
        });
      }
    },

    async update() {
      let formValid = await this.$refs.StudentReqForm.validate();

      if (formValid.valid) {
        this.btnLoading = true;
        let data = {
          requirement_submission_id: this.requirement_submission_id,
          requirement_id: this.requirement_id,
          prevFile: this.filename,
        };
        let fd = new FormData();
        fd.append("data", JSON.stringify(data));
        fd.append("file", this.file);
        this.axiosCall(
          "/student-requirement-submission/updateSubmission",
          "PATCH",
          fd,
        ).then((res) => {
          if (res.data.status == 200) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
            this.btnLoading = false;
            this.closeD();
          } else {
            this.btnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
          }
        });
      }
    },
    closeD() {
      eventBus.emit("closeSubmitRequirementsDialog", true);
      this.dialog = false;
    },

    getPrograms() {
      this.axiosCall("/program", "GET").then((res) => {
        this.programsList = res.data;
      });
    },

    viewFile(file) {
      console.log(file);
      let url =
        process.env.VUE_APP_SERVER +
        "/student-requirement-submission/get-file/" +
        file;

      let token = localStorage.getItem("token");
      const tab = window.open("about:blank");
      this.isLoading = true;
      fetch(url, { headers: { Authorization: `Bearer ${token}` } })
        .then((response) => response.blob())
        .then((blob) => {
          var _url = window.URL.createObjectURL(blob);

          tab.location = _url;
          tab.focus();
          // window.open(_url, "_blank").focus();
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
        });
      // window.open(url);
    },
  },
};
</script>

<style scoped>
.tbl {
  width: 100%;
  border-collapse: collapse;
}
</style>
